import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import nl from './locales/nl.json';

// Get saved language from localStorage or default to Dutch
const savedLanguage = localStorage.getItem('language') || 'nl';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en
      },
      nl: {
        translation: nl
      }
    },
    lng: savedLanguage,
    fallbackLng: 'nl',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
